/* eslint-disable */

/** unique or primary key constraints on table "argo.auth_provider" */
export enum ArgoAuthProviderConstraint {
  /** unique or primary key constraint on columns "auth_provider_id" */
  AuthProviderPkey = 'auth_provider_pkey'
}

/** select columns of table "argo.auth_provider" */
export enum ArgoAuthProviderSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.auth_provider" */
export enum ArgoAuthProviderUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

